import * as React from 'react';
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router';
import { initializeIcons } from '@fluentui/react';
import {
    getMeetingData,
    createOnlineMeetingAndUpdateStatus,
    endCall,
    cancelCall,
    getQueueById,
    getQueuesStatusCount,
    getStartedQueues,
    getEndedQueues,
    getExpiredQueues,
    getAttendancesReportData,
    getGeneralViewUnidadeData,
    getGeneralViewData,
    getAllQueuesData,
    getAtendentesFilter,
    getUserPermissions,
    isAdmin,
} from '../../api/teamsapp-api';
import { getUserSettings, updateUserSettings } from '../../api/user-api';
import { getAppSettings } from '../../api/settings-api';
import { Dialog, Flex, FlexItem, Image, Segment, Text } from '@fluentui/react-northstar';
import { ExclamationTriangleIcon } from '@fluentui/react-icons-northstar';
import { debounce, isDate } from 'lodash';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { IPainelAtendimentoState } from "./interfaces/interfaces";
import { LoaderList, LoaderPanel, LoaderInfinite } from "../loaders/loaders";
import VisaoGeralAtendimentosPorStatus from './visao-geral-atendimentos-status/visao-geral-atendimentos-status';
import VisaoGeralAtendimentos from '../shared/visao-geral-atendimentos/visao-geral-atendimentos';
import RelatorioAtendimentos from '../shared/relatorio-atendimentos/relatorio-atendimentos';
import ListagemFila from "./listagem-atendimentos/listagem-fila";
import ListagemIniciado from "./listagem-atendimentos/listagem-iniciado";
import ListagemEncerrado from "./listagem-atendimentos/listagem-encerrado";
import ListagemExpirado from "./listagem-atendimentos/listagem-expirado";
import ToolbarPainel from "./toolbar/toolbar";
import StatusQueueConstants from "../../constants/status-queue";
import Channels from '../../constants/channels';
import Errors from "../../constants/errors";
import Roles from "../../constants/roles";
import IdleTimer from 'react-idle-timer';
import ImagesBase64 from '../../constants/images-base64';
import "./painel-atendimento.scss";
const moment = require('moment');

export type IPainelAtendimentoProps = {} & RouteComponentProps & WithTranslation;

enum EStatus {
    inQueue = 1,
    started = 2,
    ended = 3,
    expired = 4,
}

class PainelAtendimento extends React.Component<IPainelAtendimentoProps, IPainelAtendimentoState> {
    private localize: TFunction;
    private defaultPageSize: number = 15;

    ancora?: any = null;
    serventiaTitle?: any = null;
    serventiaMeetingUrl?: any = null;
    theme?: any = null;
    upn?: any = null;
    aadId?: any = null;
    user?: any = null;
    tid?: any = null;
    appId?: any = null;
    searchParam?: any = null;
    dateParam?: any = null;
    idleTimer?: any = null;
    isChannelContext?: boolean = false;
    queueId?: any = null;
    isEndQueue?: any = null;

    constructor(props: IPainelAtendimentoProps) {
        super(props);

        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            inQueue: [],
            started: [],
            ended: [],
            expired: [],
            loading: true,
            pageSize: this.defaultPageSize,
            offset: 0,
            loadingRows: false,
            loadingInfinite: true,
            isAdmin: false,
            serventia: [],
            loadingMetricsFiltered: true,
            relatorioAtendimentosFilteredMetrics: [],
            relatorioAtendimentosIndex: 0,
            loadingAtendimentosPorStatusMetricsFiltered: true,
            atendimentosPorStatusMetricsFiltered: [],
            atendimentosPorStatusIndex: 0,
            atendimentosMetricsFiltered: [],
            loadingAtendimentosMetricsFiltered: true,
            atendimentosIndex: 0,
            userSettings: [],
            status: EStatus.inQueue,
            statusLabel: this.localize("SolicitacoesAguardandoAtendimento"),
            queueCount1: [],
            queueCount2: [],
            queueCount3: [],
            queueCount4: [],
            keepAlive: null,
            isDeleted: false,
            startedCall: false,
            startedCallAttendant: "",
            validateCreateQueue: true,
            validateQueueErrorText: "",
            isScheduledQueue: false,
            selectedDateFilter: new Date(),
            selectedDateLabel: this.localize("Hoje"),
            authEnabled: false,
            govBrEnabled: false,
            isFuture: false,
            isPast: false,
            collapsed: true,
            selectedFilter: "",
            atendentes: [],
            selectedAtendenteFilter: "",
            internalAccessEnabled: false,
            loadingUserRole: true,
            role: Roles.leitor,
            features: [],
            currentMeetingQueue: null,
            loadingQueue: false,
            loadingEndQueue: false,
            endQueueCommentsEnabled: false,
        };

        this.searchParam = new URLSearchParams(window.location.search);
        this.onScrollDebounced = debounce(this.onScrollDebounced, 500);
        this.idleTimer = null;
        this.handleOnAction = this.handleOnAction;
        this.handleOnActive = this.handleOnActive;
        this.handleOnIdle = this.handleOnIdle;
    }

    public componentDidMount = async () => {
        app.initialize();
        app.getContext().then(async (context: app.Context) => {
            this.ancora = decodeURIComponent(context.page.subPageId.split(", ")[0]);
            this.serventiaTitle = decodeURIComponent(context.page.subPageId.split(", ")[1]);
            this.appId = this.searchParam.get("appId");
            this.theme = context.app.theme;
            this.upn = context.user.userPrincipalName;
            this.aadId = context.user.id;
            this.user = context.user.loginHint;
            this.tid = context.user.tenant;
            this.dateParam = context.page.subPageId.split(", ")[2];
            this.queueId = context.page.subPageId?.split(", ")[3] ?? null;
            this.isEndQueue = context.page.subPageId?.split(", ")[4] ?? null,
            this.isChannelContext = context.channel != undefined;

            // INTERNAL (BOT) CHANNEL USE
            if (this.searchParam.get("ancora"))
                this.ancora = decodeURIComponent(this.searchParam.get("ancora"))

            // INTERNAL (BOT) CHANNEL USE
            if (this.searchParam.get("title"))
                this.serventiaTitle = decodeURIComponent(this.searchParam.get("title"))

            // INTERNAL (BOT) CHANNEL USE
            if (this.isEndQueue != null && this.isEndQueue == "end") {
                this.isEndQueue = true;
            }

            await this.getUserRole();
            await this.getUserSettings();
        });
    }

    // Init methods
    public init = async () => {
        if (this.ancora) {
            await this.getMeeting();
            this.addLastViewUnidade();
        } else {
            this.ancora = this.state.userSettings.lastViewUnidadeAncora;
            this.serventiaTitle = this.state.userSettings.lastViewUnidadeTitle;

            if (this.ancora)
                await this.getMeeting();
        }

        const date = new Date(this.dateParam);
        const isValidDate = !isNaN(date.getTime());

        if (isValidDate) {
            this.applyFilters(new Date(this.dateParam), null);
        }

        this.setState({
            keepAlive: setInterval(() => this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
        });

        this.getAppSettings();
        this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true);
        this.getAtendimentosPorStatusFilteredMetrics(0);
        this.getAtendimentosFilteredMetrics(0);
        this.getRelatorioAtendimentosFilteredMetrics(7);
        this.getAtendentes(this.state.selectedDateFilter);

        // Start call from bot.
        // INTERNAL (BOT) CHANNEL USE
        { this.queueId && !this.isEndQueue && this.getQueueById("start") }

        // End call from bot.
        // INTERNAL (BOT) CHANNEL USE
        { this.queueId && this.isEndQueue && this.getQueueById("end") }
    }

    // Get app audience
    public getUserRole = async () => {
        const responseIsAdmin = await isAdmin();
        const responseUserRole = await getUserPermissions();

        if (responseIsAdmin.status === 200 && responseIsAdmin.data) {
            this.setState({
                isAdmin: responseIsAdmin.data,
            })
        }

        if (responseUserRole.status === 200 && responseUserRole.data) {
            this.setState({
                role: responseUserRole.data,
                loadingUserRole: false,
            })
        }
    }

    //Get user settings.
    public getUserSettings = async () => {
        const response = await getUserSettings();

        if (response.data) {
            this.setState({
                userSettings: response.data
            })

            this.init();
        }
        else {
            window.location.href = `/errorpage/${Errors.invalidUserData}`;
        }
    }

    //Get app settings.
    public getAppSettings = async () => {
        let response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                features: response.data.featuresList,
            })
        }
    }

    //Get serventia by id.
    public getMeeting = async () => {
        const response = await getMeetingData(this.ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                serventia: response.data,
                isDeleted: response.data.deleted,
                isScheduledQueue: response.data.scheduledQueue || response.data.supportedChannels?.includes(Channels.bookings),
                authEnabled: response.data.authEnabled,
                govBrEnabled: response.data.govBrEnabled,
                internalAccessEnabled: response.data.supportedChannels?.includes(Channels.bot) ?? false,
                role: response.data.isAuthorized ? Roles.atendente : Roles.leitor,
                endQueueCommentsEnabled: response.data.endQueueCommentsEnabled,
            });
        }
    }

    //Insert the last view unit
    public addLastViewUnidade = async () => {
        this.state.userSettings.lastViewUnidadeAncora = this.ancora;
        this.state.userSettings.lastViewUnidadeTitle = this.serventiaTitle;

        await updateUserSettings(this.state.userSettings);
    }

    // Get queue by id.
    public getQueueById = async (trigger: "start" | "end") => {
        const response = await getQueueById(this.queueId);

        if (response.status === 200 && response.data) {
            if (trigger == "start" &&
                (response.data.status === StatusQueueConstants.naFila ||
                 response.data.status === StatusQueueConstants.atendimentoIniciado ||
                 response.data.status === StatusQueueConstants.emAtendimento)) {
                this.setState({
                    loadingQueue: true,
                    currentMeetingQueue: response.data,
                });

                this.startCall(response.data);
            } else if (trigger == "start" && response.data.status === StatusQueueConstants.atendimentoAgendado) {
                const now = moment();
                const scheduleDateString = response.data.Schedule?.date;
                const scheduleDate = moment(scheduleDateString);

                const scheduleDay = scheduleDate.isSame(now, 'day');
                const scheduleDayRangeStart = moment(scheduleDate).subtract(30, 'minutes');
                const scheduleDayRangeEnd = moment(scheduleDate).add(30, 'minutes');

                const scheduleDayInRange = now.isBetween(scheduleDayRangeStart, scheduleDayRangeEnd, undefined, '[]');
                const scheduleExpired = now.isAfter(scheduleDayRangeEnd);

                if (scheduleDay && scheduleDayInRange) {
                    this.setState({
                        loadingQueue: true,
                        currentMeetingQueue: response.data,
                    });

                    this.startCall(response.data);
                }
            } else if (trigger == "end" && response.data.status === StatusQueueConstants.emAtendimento) {
                this.setState({
                    loadingEndQueue: true,
                    currentMeetingQueue: response.data,
                });
                this.endCall(response.data);
            } else {
                this.setState({ loadingQueue: false });
                this.queueId = null;
            }
        }
    }

    // Get in queue data.
    public getInQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string, alive?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        const response = await getAllQueuesData(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters, this.state.internalAccessEnabled);

        if (response.data.length < this.defaultPageSize)
            this.setState({
                loadingInfinite: false,
            });

        if (response.status === 200 && response.data.length) {
            this.setState({
                inQueue: alive ? response.data : [...this.state.inQueue, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            });
        }

        this.getQueuesStatusCount(date, atendenteId, filters);
    }

    // Get started queue data. 
    public getStartedQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string, alive?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        const response = await getStartedQueues(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters, this.state.internalAccessEnabled);

        if (response.data.length < this.defaultPageSize)
            this.setState({
                loadingInfinite: false,
            });

        if (response.status === 200 && response.data) {
            this.setState({
                started: alive ? response.data : [...this.state.started, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            });
        }

        this.getQueuesStatusCount(date, atendenteId, filters);
    }

    // Get ended queue data. 
    public getEndedQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string, fromTab?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        const response = await getEndedQueues(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters);

        if (response.data.length < this.defaultPageSize)
            this.setState({
                loadingInfinite: false,
            });

        if (response.status === 200 && response.data.length) {
            this.setState({
                ended: fromTab ? response.data : [...this.state.ended, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            });
        }

        this.getQueuesStatusCount(date, atendenteId);
    }

    // Get expired queue data. 
    public getExpiredQueueData = async (offset: number, date?: Date | null, filters?: string, fromTab?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        const response = await getExpiredQueues(this.ancora, offset, this.defaultPageSize, date, filters);

        if (response.data.length < this.defaultPageSize)
            this.setState({
                loadingInfinite: false,
            });

        if (response.status === 200 && response.data.length) {
            this.setState({
                expired: fromTab ? response.data : [...this.state.expired, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            });
        }

        this.getQueuesStatusCount(date, filters);
    }

    // Get queues status count.
    public getQueuesStatusCount = async (date?: Date | null, atendenteId?: string, filters?: string) => {
        if (date) {
            date = moment(date).toISOString();
        }

        let response = await getQueuesStatusCount(this.ancora, date, atendenteId, filters, this.state.internalAccessEnabled);

        if (response.status === 200 && response.data) {
            this.setState({
                queueCount1: response.data.filter((queue: any) => queue.status == StatusQueueConstants.naFila || queue.status == StatusQueueConstants.atendimentoAgendado),
                queueCount2: response.data.filter((queue: any) => queue.status == StatusQueueConstants.atendimentoIniciado || queue.status == StatusQueueConstants.emAtendimento),
                queueCount3: response.data.filter((queue: any) => (queue.status == StatusQueueConstants.atendimentoEncerrado || queue.status == StatusQueueConstants.atendimentoInativo || queue.status == StatusQueueConstants.atendimentoCancelado) && (!queue.expired || queue.status == StatusQueueConstants.atendimentoCancelado)),
                queueCount4: response.data.filter((queue: any) => queue.status == StatusQueueConstants.atendimentoInativo && queue.expired),
            })
        }
    }

    // Get visão geral atendimentos filter metrics
    public getAtendimentosPorStatusFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingAtendimentosPorStatusMetricsFiltered: true,
            });
        }

        let response = await getGeneralViewUnidadeData(this.ancora, daysCount);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosPorStatusMetricsFiltered: response.data,
                loadingAtendimentosPorStatusMetricsFiltered: false,
                atendimentosPorStatusIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                atendimentosPorStatusMetricsFiltered: null,
                loadingAtendimentosPorStatusMetricsFiltered: false,
            });
        }
    }

    // Get visão geral filter metrics by ancora
    public getAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingAtendimentosMetricsFiltered: true,
            });
        }

        let response = await getGeneralViewData(daysCount, this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosMetricsFiltered: response.data,
                loadingAtendimentosMetricsFiltered: false,
                atendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                atendimentosMetricsFiltered: null,
                loadingAtendimentosMetricsFiltered: false,
            });
        }
    }

    // Get relatório de atendimentos.
    public getRelatorioAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingMetricsFiltered: true,
            });
        }

        let response = await getAttendancesReportData(daysCount, this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                relatorioAtendimentosFilteredMetrics: response.data,
                loadingMetricsFiltered: false,
                relatorioAtendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                relatorioAtendimentosFilteredMetrics: null,
                loadingMetricsFiltered: false,
            });
        }
    }

    // Filter assunto or protocol.
    public filterAssuntoOrProtocol = async (filter: string) => {
        this.stopKeepAlive();

        this.setState({
            selectedFilter: filter,
            status: EStatus.inQueue,
        }, () => {
            this.setActiveTabId(EStatus.inQueue);
        })
    }

    // Get unit atendentes
    public getAtendentes = async (date: Date) => {
        let response = await getAtendentesFilter(this.ancora, date);

        if (response.status === 200 && response.data) {
            this.setState({
                atendentes: response.data,
            })
        }
    }

    // Search
    public searchFilters = (e: React.SyntheticEvent<HTMLElement, Event>) => {
        let searchQuery = (e.target as HTMLInputElement).value;

        this.setState({
            selectedFilter: searchQuery,
        })
    }

    // Apply custom filters
    public applyFilters = (dateFilter: any, atendenteFilter: string | null) => {
        this.stopKeepAlive();

        if (atendenteFilter) {
            this.setState({
                selectedDateFilter: dateFilter,
                selectedAtendenteFilter: atendenteFilter,
                selectedFilter: "",
            }, () => {
                if (moment(dateFilter).isSame(moment(), "day")) {
                    this.setActiveTabId(EStatus.started);
                } else {
                    if (moment(dateFilter).isBefore(moment(), "day"))
                        this.setActiveTabId(EStatus.ended);

                    if (moment(dateFilter).isAfter(moment(), "day"))
                        this.setActiveTabId(EStatus.inQueue);
                }
            })
        } else {
            this.dateChange(dateFilter);
        }
    }

    // Apply protocol or subject filter
    public applyProtocolFilter = () => {
        this.setState({
            status: 0,
            loadingRows: true,
            selectedAtendenteFilter: "",
        }, () => {
            this.stopKeepAlive();
            this.filterAssuntoOrProtocol(this.state.selectedFilter.replace(/#/g, ""));
        });
    }

    // Clear all filters
    public clearFilters = () => {
        this.setState({
            selectedFilter: "",
            loadingRows: true,
            status: EStatus.inQueue,
            statusLabel: this.localize("SolicitacoesAguardandoAtendimento"),
            selectedAtendenteFilter: "",
            selectedDateFilter: new Date(),
            isPast: false,
            isFuture: false,
        }, () => {
            this.stopKeepAlive();
            this.getInQueueData(this.state.offset, new Date());
            this.setState({ keepAlive: setInterval(() => this.getInQueueData(this.state.offset, new Date(), "", "", true), 20000) });
        })
    }

    // Date filter change
    public dateChange = (date: any) => {
        this.setState({
            status: 0,
            selectedDateFilter: date,
            loadingRows: true,
        }, () => {
            if (moment(date).isSame(moment(), "day")) {
                this.setState({
                    isFuture: false,
                    isPast: false,
                });

                this.setActiveTabId(EStatus.inQueue);
            } else {
                if (moment(date).isBefore(moment(), "day")) {
                    this.setState({
                        isFuture: false,
                        isPast: true,
                        selectedDateLabel: moment(date).format("DD/MM/YY"),
                    });

                    this.setActiveTabId(EStatus.ended);
                }

                if (moment(date).isAfter(moment(), "day")) {
                    this.setState({
                        isFuture: true,
                        isPast: false,
                        selectedDateLabel: moment(date).format("DD/MM/YY"),
                    });

                    this.setActiveTabId(EStatus.inQueue);
                }
            }
        })
    }

    // Parse status labels
    public getLabelStatusLocale = (status?: string) => {
        if (status) {
            if (status == StatusQueueConstants.naFila)
                return this.localize("NaFila")
            else if (status == StatusQueueConstants.atendimentoIniciado)
                return this.localize("AtendimentoIniciado")
            else if (status == StatusQueueConstants.emAtendimento)
                return this.localize("EmAtendimento")
            else if (status == StatusQueueConstants.atendimentoEncerrado)
                return this.localize("AtendimentoEncerrado")
            else if (status == StatusQueueConstants.atendimentoInativo)
                return this.localize("AtendimentoInativo")
            else if (status == StatusQueueConstants.atendimentoCancelado)
                return this.localize("AtendimentoCancelado")
            else if (status == StatusQueueConstants.atendimentoAgendado)
                return this.localize("Agendado")
        }
    }

    // Get tab status locale
    public getTabStatusLocale() {
        return [
            { title: this.localize("SolicitacoesAguardandoAtendimento") },
            { title: this.localize("AtendimentosIniciados") },
            { title: this.localize("EmAtendimento") },
            { title: this.localize("SolicitacoesExpiradas") },
        ]
    }

    //"Search function"
    public onScroll = (e: any) => {
        if (e.target.className == "main-component-painel")
            this.onScrollDebounced(e.target)
    }

    // Scroll infinite pagination
    public onScrollDebounced = (e: any) => {
        const bottom = Math.floor(e.scrollHeight - e.scrollTop) <= Math.floor(e.clientHeight);

        if (!this.state.loadingInfinite)
            return;

        if (bottom && !this.state.loadingRows) {
            this.stopKeepAlive();

            this.setState({
                offset: this.state.offset + this.defaultPageSize,
            }, () => {
                { this.state.status == EStatus.inQueue && this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.started && this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.ended && this.getEndedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.expired && this.getExpiredQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter) }
            })
        }
    }

    // Set active tab
    public setActiveTabId = (index: number) => {
        this.stopKeepAlive();

        this.setState({
            status: index,
            statusLabel: this.getTabStatusLocale()[index - 1].title,
            loadingRows: true,
            loadingInfinite: true,
            offset: 0,
            pageSize: this.defaultPageSize,
            inQueue: [],
            started: [],
            ended: [],
            expired: [],
        }, () => {
            if (index == EStatus.inQueue) {
                this.setState({
                    keepAlive: setInterval(() => this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
                });

                this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
            }

            if (index == EStatus.started) {
                this.setState({
                    keepAlive: setInterval(() => this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
                });

                this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
            }

            if (index == EStatus.ended) {
                this.getEndedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
            }

            if (index == EStatus.expired) {
                this.getExpiredQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter, true)
            }

        })
    }

    // Iniciar atendimento
    public startCall = async (item: any) => {
        item.loadingMeeting = true;

        this.setState({
            inQueue: this.state.inQueue
        })

        await getQueueById(item.id).then(async (queue: any) => {
            if ((queue.data.status == StatusQueueConstants.atendimentoIniciado ||
                queue.data.status == StatusQueueConstants.emAtendimento) &&
                queue.data.channel != Channels.bot) {

                item.loadingMeeting = false;

                this.setState({
                    currentMeetingQueue: queue,
                    loadingQueue: false,
                    startedCall: true,
                    startedCallAttendant: queue.data.atendenteName,
                });
            } else if (queue.data.status == StatusQueueConstants.emAtendimento &&
                       queue.data.channel == Channels.bot) {
                this.setState({
                    currentMeetingQueue: queue,
                    loadingQueue: false,
                    startedCall: true,
                    startedCallAttendant: queue.data.atendenteName,
                })
            } else if ((queue.data.status == StatusQueueConstants.naFila || queue.data.status == StatusQueueConstants.atendimentoAgendado) ||
                        queue.data.status == StatusQueueConstants.atendimentoIniciado && queue.data.channel == Channels.bot) {
                await createOnlineMeetingAndUpdateStatus(item.id, item.Ancora, this.appId).then((response: any) => {
                    if (response.status === 409) {
                        item.loadingMeeting = false;

                        this.setState({
                            currentMeetingQueue: queue,
                            loadingQueue: false,
                            startedCall: true,
                            startedCallAttendant: queue.data.atendenteName,
                        });
                    }

                    if (response.data.id) {
                        let url = null;

                        if (response.data.channel === Channels.bot) {
                            url = window.location.ancestorOrigins[0].includes("cloud") ?
                                `https://teams.cloud.microsoft/l/chat/${response.data.OnlineMeetingData?.chatInfo?.threadId}` : `https://teams.microsoft.com/l/chat/${response.data.OnlineMeetingData?.chatInfo?.threadId}`;
                        } else {
                            this.setState({ inQueue: this.state.inQueue })

                            url = window.location.ancestorOrigins[0].includes("cloud") ?
                                response.data.meetingUrl.replace("https://teams.microsoft.com", "https://teams.cloud.microsoft") :
                                response.data.meetingUrl;
                        }

                        app.openLink(url);

                        this.getInQueueData(this.state.offset, this.state.selectedDateFilter)
                            .then(() => {
                                this.setState({ loadingQueue: false });
                                this.queueId = null;
                                this.setActiveTabId(EStatus.started);
                            });
                    } else {
                        this.setState({
                            validateCreateQueue: false,
                            validateQueueErrorText: response.data,
                        })
                    }

                })
            }
        })
    }

    // Finalizar atendimento
    public endCall = async (item: any) => {
        if (item) {
            const justification = item.justification;

            await endCall(item.id, justification).then(() => {
                this.getEndedQueueData(this.state.offset, this.state.selectedDateFilter).then(() => this.setActiveTabId(EStatus.ended));
                this.setState({ loadingEndQueue: false });
                item.loadingEndMeeting = false;
            })
        }
    }

    // Task module details
    public onViewHistory = (queueId: any) => {
        let taskInfo: UrlDialogInfo = {
            url: window.location.origin + `/post-meeting-panel/${queueId}/${this.ancora}`,
            title: this.localize("Detalhes"),
            size: {
                height: 650,
                width: 930,
            },
        }

        dialog.url.open(taskInfo);
    }

    // Schedule queue
    public agendar = (queueId?: string | null) => {
        const cat = this.searchParam.get("cat");

        let url = `${window.location.origin}/agendamento?ancora=${this.ancora}&appId=${this.appId}${queueId ? `&queueId=${queueId}` : ''}`;

        if (cat) {
            url += `&cat=${cat}`;
        }

        let taskInfo: UrlDialogInfo = {
            url,
            title: this.localize("Agendamento"),
            size: {
                height: 600,
                width: 800,
            },
        }

        let submitHandler = (submitHandler): void => {
            if (submitHandler.result != null) {
                this.setActiveTabId(EStatus.inQueue)
            }
        };

        dialog.url.open(taskInfo, submitHandler);
    }

    // Cancel meeting
    public onCancelCall = (queueId: any) => {
        cancelCall(queueId).then(() => {
            this.getInQueueData(this.state.offset, this.state.selectedDateFilter).then(() => this.setActiveTabId(EStatus.ended));
        })
    }

    // Collapse charts area
    public collapseCharts = (collapsed: boolean) => {
        this.setState({
            collapsed: collapsed
        })
    }

    // Validate create queue
    public onValidateCreateQueue = () => {
        this.setState({ validateCreateQueue: true })
    }


    // Idle user timeout methods - On user action
    public handleOnAction = (event: any) => {
    }

    // Idle user timeout methods - User is active
    public handleOnActive = (event: any) => {
        if (this.state.status === 1) {
            this.setState({
                offset: 0,
                pageSize: this.defaultPageSize,
                keepAlive: setInterval(() => this.getInQueueData(0, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
            });
        }

        if (this.state.status === 2) {
            this.setState({
                offset: 0,
                pageSize: this.defaultPageSize,
                keepAlive: setInterval(() => this.getStartedQueueData(0, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
            });
        }
    }

    // Idle user timeout methods - User is idle
    public handleOnIdle = (event: any) => {
        this.stopKeepAlive();
    }

    public stopKeepAlive = () => {
        clearInterval(this.state.keepAlive);
        this.setState({ keepAlive: null });
    }


    public render = () => {
        return (this.state.loadingAtendimentosMetricsFiltered ||
                this.state.loadingAtendimentosPorStatusMetricsFiltered ||
                this.state.loadingMetricsFiltered ||
                this.state.loadingUserRole ?
                    <LoaderPanel />
                :
                !this.ancora ?
                    <div className="main-component-painel">
                        <Flex className="form-container" column>
                            <Flex>
                                <Flex vAlign="center" hAlign="center" styles={{ width: "100%", height: "100vh" }}>
                                    <Flex hAlign="center" gap="gap.large" column style={{ width: "100%", maxWidth: "43.5rem", margin: "0rem 1.25rem", height: "90rem" }}>
                                        <Image src="https://studio365cdn.azureedge.net/balcaovirtual/empty-unit.svg" />
                                        <Text size="larger" content="Você ainda não acessou uma unidade." />
                                        <Text content={this.localize("SelecioneServentia")} />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    </div>
                    :
                    <div className="main-component-painel" onScroll={this.onScroll}>
                        <IdleTimer
                            ref={(ref: any) => { this.idleTimer = ref }}
                            timeout={300000}
                            onActive={this.handleOnActive}
                            onIdle={this.handleOnIdle}
                            onAction={this.handleOnAction}
                            debounce={250}
                        />
                        {this.state.loadingQueue &&
                            <Flex className="loaderMeetingQueue" hAlign="center" vAlign="center">
                                <Flex className="content" gap="gap.large" hAlign="center" column>
                                    <Image className="logoImg" src={this.theme === "dark" ? ImagesBase64.iconWhite : ImagesBase64.icon} />
                                    <Text content={this.localize("IniciandoReuniao")} />
                                    <LoaderInfinite />
                                </Flex>
                            </Flex>
                        }

                        {this.state.loadingEndQueue &&
                            <Flex className="loaderMeetingQueue" hAlign="center" vAlign="center">
                                <Flex className="content" gap="gap.large" hAlign="center" column>
                                    <Image className="logoImg" src={this.theme === "dark" ? ImagesBase64.iconWhite : ImagesBase64.icon} />
                                    <Text content={this.localize("EncerrandoReuniao")} />
                                    <LoaderInfinite />
                                </Flex>
                            </Flex>
                        }
                        <div className="form-container">
                            <Flex gap="gap.large" space="between">
                                <FlexItem size="size.quarter">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        {<VisaoGeralAtendimentos
                                            metrics={this.state.atendimentosMetricsFiltered}
                                            filter={this.getAtendimentosFilteredMetrics}
                                            index={this.state.atendimentosIndex}
                                            customTitle={this.serventiaTitle}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                        />}
                                    </Segment>
                                </FlexItem>

                                <FlexItem size="size.quarter">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        <VisaoGeralAtendimentosPorStatus
                                            metrics={this.state.atendimentosPorStatusMetricsFiltered}
                                            filter={this.getAtendimentosPorStatusFilteredMetrics}
                                            index={this.state.atendimentosPorStatusIndex}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                        />
                                    </Segment>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        {<RelatorioAtendimentos
                                            metrics={this.state.relatorioAtendimentosFilteredMetrics}
                                            filter={this.getRelatorioAtendimentosFilteredMetrics}
                                            index={this.state.relatorioAtendimentosIndex}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                            theme={this.theme}
                                        />}
                                    </Segment>
                                </FlexItem>
                            </Flex>

                            <Flex space="between" className="toolbar-painel">
                                <ToolbarPainel
                                    ancora={this.ancora}
                                    status={this.state.status}
                                    setActiveTabId={this.setActiveTabId}
                                    queueCount1={this.state.queueCount1}
                                    queueCount2={this.state.queueCount2}
                                    queueCount3={this.state.queueCount3}
                                    queueCount4={this.state.queueCount4}
                                    agendar={this.agendar}
                                    isScheduledQueue={this.state.isScheduledQueue}
                                    dataChange={this.dateChange}
                                    selectedDateFilter={this.state.selectedDateFilter}
                                    selectedDateLabel={this.state.selectedDateLabel}
                                    isFuture={this.state.isFuture}
                                    isPast={this.state.isPast}
                                    searchFilters={this.searchFilters}
                                    selectedFilter={this.state.selectedFilter}
                                    clearFilters={this.clearFilters}
                                    applyFilters={this.applyFilters}
                                    applyProtocolFilter={this.applyProtocolFilter}
                                    atendentes={this.state.atendentes}
                                    getAtendentesByDate={this.getAtendentes}
                                    selectedAtendenteFilter={this.state.selectedAtendenteFilter}
                                    role={this.state.role}
                                    isAdmin={this.state.isAdmin}
                                    collapseCharts={this.collapseCharts}
                                    collapsed={this.state.collapsed}
                                    features={this.state.features}
                                />
                            </Flex>

                            <div style={{ position: "relative", zIndex: 999, boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Flex className="form-content-container" column>
                                    {(!this.state.loadingRows && !this.state.isDeleted && this.state.status == 0) &&
                                        <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px' }}>
                                            <ExclamationTriangleIcon outline />
                                            <Text size="small" weight="light" content={`Não existem atendimentos com o filtro selecionado.`} />
                                        </Flex>
                                    }

                                    {this.state.loadingRows && <LoaderList />}

                                    <Dialog
                                        open={this.state.startedCall}
                                        onConfirm={() => {
                                            this.setState({ startedCall: false });
                                            const currentQueue = this.state.currentMeetingQueue;

                                            if (currentQueue.channel == Channels.bot &&
                                                currentQueue.status == StatusQueueConstants.emAtendimento &&
                                                currentQueue.OnlineMeetingData != null) {

                                                const chatUrl = window.location.ancestorOrigins[0].includes("cloud") ?
                                                    `https://teams.cloud.microsoft/l/chat/${currentQueue.OnlineMeetingData?.chatInfo?.threadId}` : `https://teams.microsoft.com/l/chat/${currentQueue.OnlineMeetingData?.chatInfo?.threadId}`;

                                                app.openLink(chatUrl);
                                            }

                                            this.stopKeepAlive();
                                            this.setState({
                                                loadingRows: true,
                                                offset: 0,
                                                pageSize: this.defaultPageSize,
                                                inQueue: [],
                                            }, () => {
                                                if (this.state.status == EStatus.inQueue) {
                                                    this.setState({
                                                        keepAlive: setInterval(() => this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
                                                    });

                                                    this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
                                                }
                                            })
                                        }}
                                        confirmButton="Ok"
                                        content={`${this.localize("SolicitacaoJaAtendida")} ${this.state.startedCallAttendant}.`}
                                        header={this.localize("AtenderEstaSolicitacao")}
                                    />

                                    {(!this.state.loadingRows && this.state.status == EStatus.inQueue) &&
                                        <ListagemFila
                                            item={this.state.inQueue}
                                            status={this.state.statusLabel}
                                            isScheduledQueue={this.state.isScheduledQueue}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onCancelCall={this.onCancelCall}
                                            validateCreateQueue={this.state.validateCreateQueue}
                                            validateQueueErrorText={this.state.validateQueueErrorText}
                                            onValidateCreateQueue={this.onValidateCreateQueue}
                                            startCall={this.startCall}
                                            agendar={this.agendar}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            filtered={
                                                this.state.isPast ||
                                                this.state.isFuture ||
                                                (this.state.selectedFilter != "") ||
                                                (this.state.selectedAtendenteFilter != "")}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                            onViewHistory={this.onViewHistory}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.started) &&
                                        <ListagemIniciado
                                            item={this.state.started}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onCancelCall={this.onCancelCall}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            aadId={this.aadId}
                                            finalizar={this.endCall}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                            onViewHistory={this.onViewHistory}
                                            endQueueCommentsEnabled={this.state.endQueueCommentsEnabled}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.ended) &&
                                        <ListagemEncerrado
                                            item={this.state.ended}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onViewHistory={this.onViewHistory}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            filtered={(this.state.selectedFilter != "") || (this.state.selectedAtendenteFilter != "")}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.expired) &&
                                        <ListagemExpirado
                                            item={this.state.expired}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onViewHistory={this.onViewHistory}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }
                                </Flex>
                            </div>
                        </div>
                    </div>
        );
    }
}

const painelAtendimentoWithTranslation = withTranslation()(PainelAtendimento);
export default painelAtendimentoWithTranslation;
